import { render, staticRenderFns } from "./ReasonSelector.vue?vue&type=template&id=4e077af2&scoped=true&"
import script from "./ReasonSelector.vue?vue&type=script&lang=js&"
export * from "./ReasonSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReasonSelector.vue?vue&type=style&index=0&id=4e077af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e077af2",
  null
  
)

export default component.exports